import { BuildingReviewLandingAutocompleteStatechart } from 'common/module/building-review-landing/autocomplete/statechart';
import { StatechartStoreFactory } from 'common/module/statechart/store.factory';

const service = StatechartStoreFactory();

service.initialize({
  statechart: BuildingReviewLandingAutocompleteStatechart,
});

export const BuildingReviewLandingAutocompleteStatechartService = () => service;
